import { Objects } from '../object-definitions'

export namespace Chili {
    export function getDateBasedSubFolder(referenceDate: Date, precision: 'hour' | 'minute' | 'second') {
        const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

        const year = referenceDate.getUTCFullYear()
        const month = referenceDate.getUTCMonth()
        const date = referenceDate.getUTCDate()
        const hour = referenceDate.getUTCHours()
        const minutes = referenceDate.getUTCMinutes()
        const seconds = referenceDate.getUTCSeconds()

        const minuteSuffix = precision === 'minute' || precision === 'second' ? `/${minutes < 10 ? '0' + minutes : minutes}` : ''
        const secondsSuffix = precision === 'second' ? `/${seconds < 10 ? '0' + seconds : seconds}` : ''

        return `${year}/${MONTHS[month]}/${date < 10 ? '0' + date : date}/${hour < 10 ? '0' + hour : hour}${minuteSuffix}${secondsSuffix}`
    }

    export function getDocumentDimensions(document: Objects.Chili.Document) {
        const width = +document.document.$.width.substring(0, document.document.$.width.indexOf(' mm'))
        const height = +document.document.$.height.substring(0, document.document.$.height.indexOf(' mm'))

        const widthInches = Math.round((width / 25.4 + Number.EPSILON) * 100) / 100
        const heightInches = Math.round((height / 25.4 + Number.EPSILON) * 100) / 100

        return {
            widthInches,
            heightInches,
        }
    }

    export function getRemoteModificationDate(date: Date) {
        const day = date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate()

        const dateMonth = date.getUTCMonth() + 1
        const month = dateMonth < 10 ? '0' + dateMonth : dateMonth
        const hour = date.getUTCHours() < 10 ? '0' + date.getUTCHours() : date.getUTCHours()
        const minute = date.getUTCMinutes() < 10 ? '0' + date.getUTCMinutes() : date.getUTCMinutes()
        const seconds = date.getUTCSeconds() < 10 ? '0' + date.getUTCSeconds() : date.getUTCSeconds()
        const year = date.getUTCFullYear()

        return `${day}/${month}/${year} ${hour}:${minute}:${seconds}`
    }

    export function getAssetIdAndName(documentID: string, image: Objects.ImageAsset.Parse | { id: string }, date: Date) {
        return `${documentID}-${image.id}-${date.getTime()}`
    }

    export function getImagePositionForFrame(
        img: { widthPx: number; heightPx: number },
        frame: { widthMM: number; heightMM: number },
        extractOptionsPx: { left: number; top: number; width: number; height: number }
    ) {
        const imgWidthMM = (img.widthPx / extractOptionsPx.width) * frame.widthMM
        const imgHeightMM = (img.heightPx / extractOptionsPx.height) * frame.heightMM
        const imgXMM = (-extractOptionsPx.left / img.widthPx) * imgWidthMM
        const imgYMM = (-extractOptionsPx.top / img.heightPx) * imgHeightMM

        return {
            imgXMM,
            imgYMM,
            imgWidthMM,
            imgHeightMM,
        }
    }
}
